// src/store/slices/orderSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  currentOrder: null,
  total: 0,
  page: 1,
  limit: 20,
  loading: false,
  error: null,
  stats: {
    total: 0,
    pending: 0,
    processing: 0,
    shipped: 0,
    delivered: 0,
    cancelled: 0,
    revenue: 0,
  },
  filters: {
    status: 'all',
    dateRange: null,
    search: '',
  },
};

const orderSlice = createSlice({
  name: 'orders',
  initialState,
  reducers: {
    setOrders: (state, action) => {
      state.orders = action.payload.orders;
      state.total = action.payload.total || action.payload.orders.length;
    },
    setCurrentOrder: (state, action) => {
      state.currentOrder = action.payload;
    },
    addOrder: (state, action) => {
      state.orders.unshift(action.payload);
      state.total += 1;
    },
    updateOrder: (state, action) => {
      const index = state.orders.findIndex(
        (o) => o.id === action.payload.id
      );
      if (index !== -1) {
        state.orders[index] = action.payload;
      }
      if (state.currentOrder?.id === action.payload.id) {
        state.currentOrder = action.payload;
      }
    },
    updateOrderStatus: (state, action) => {
      const { id, status } = action.payload;
      const order = state.orders.find((o) => o.id === id);
      if (order) {
        order.status = status;
      }
      if (state.currentOrder?.id === id) {
        state.currentOrder.status = status;
      }
    },
    setOrderStats: (state, action) => {
      state.stats = {
        ...state.stats,
        ...action.payload,
      };
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setLimit: (state, action) => {
      state.limit = action.payload;
    },
    setOrderFilters: (state, action) => {
      state.filters = {
        ...state.filters,
        ...action.payload,
      };
    },
    resetOrderFilters: (state) => {
      state.filters = {
        status: 'all',
        dateRange: null,
        search: '',
      };
    },
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearError: (state) => {
      state.error = null;
    },
    resetOrderState: (state) => {
      return initialState;
    },
  },
});

// Actions
export const {
  setOrders,
  setCurrentOrder,
  addOrder,
  updateOrder,
  updateOrderStatus,
  setOrderStats,
  setPage,
  setLimit,
  setOrderFilters,
  resetOrderFilters,
  setLoading,
  setError,
  clearError,
  resetOrderState,
} = orderSlice.actions;

// Selectors
export const selectOrders = (state) => state.orders.orders;
export const selectCurrentOrder = (state) => state.orders.currentOrder;
export const selectTotalOrders = (state) => state.orders.total;
export const selectOrderPage = (state) => state.orders.page;
export const selectOrderLimit = (state) => state.orders.limit;
export const selectOrderFilters = (state) => state.orders.filters;
export const selectOrderStats = (state) => state.orders.stats;
export const selectOrderLoading = (state) => state.orders.loading;
export const selectOrderError = (state) => state.orders.error;

export default orderSlice.reducer;